import styled from 'styled-components'
import InputMask from 'react-input-mask'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

type ContainerProps = {
  width: number
  height: number
}

export const InputContainer = styled.div<ContainerProps>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  & > input.invalid {
    border-color: rgb(229, 62, 62);
    text-decoration-color: rgb(229, 62, 62);
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
`

export const Input = styled(InputMask)`
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  border: 1px solid ${(props) => props.theme.neutral.main};
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  line-height: 17px;
  color: rgb(160, 164, 179);
  padding-left: 16px;
`

export const ErrorText = styled.div`
  font-size: 10px;
  line-height: 20px;
  color: ${(props) => props.theme.error};
`
